import gql from 'graphql-tag';
import React from 'react';
import { Query } from 'react-apollo';
import { RouteComponentProps } from 'react-router';
import { mapOtherServiceAssignments } from '@getnoble/noble-tip-splitting-utils';
import { Layout, LayoutContent, Navigation } from '../../../components';
import { DeliveryLayoutRow, DeliverySeparator } from '../components';
import { deliveryCategoryFragment, deliveryLayoutFragment } from '../../../fragments';
import { DeliveryLocationFields } from '../../../fragments/__generated__/DeliveryLocationFields';
// import { DeliveryLayoutFields } from '../../../fragments/__generated__/DeliveryLayoutFields';
import {
  FulfillmentCenterDeliveryLayoutQuery,
  FulfillmentCenterDeliveryLayoutQueryVariables,
} from './__generated__/FulfillmentCenterDeliveryLayoutQuery';
import './Layout.scss';

interface FulfillmentCentersDeliveryLayoutRouterParams {
  venueId: string;
  fulfillmentCenterId: string;
  parentLocationId: string;
  categoryId: string;
}

type RouterProps = RouteComponentProps<FulfillmentCentersDeliveryLayoutRouterParams>;

interface FulfillmentCentersDeliveryLayoutProps extends RouterProps {
  data?: FulfillmentCenterDeliveryLayoutQuery;
  loading: boolean;
  error?: Error;
  venueId: string;
  fulfillmentCenterId: string;
}

class FulfillmentCentersDeliveryLayoutUnwrapped extends React.Component<FulfillmentCentersDeliveryLayoutProps, any> {
  createUrl = (location: DeliveryLocationFields) => {
    const { venueId, fulfillmentCenterId } = this.props.match.params;
    return `/venue/${venueId}/fulfillment-centers/${fulfillmentCenterId}/delivery/layout/${location.id}`;
  };

  renderContent() {
    if (this.props.loading || !this.props.data) {
      return <p>Loading...</p>;
    } else {
      const { fulfillmentCenter, fulfillmentCenterDeliveryLayout, fulfillmentCenterAssignments } = this.props.data;
      const mappedOtherAssignments = mapOtherServiceAssignments(fulfillmentCenterAssignments);

      if (!fulfillmentCenterDeliveryLayout) {
        return (
          <div className='delivery-layout-container'>
            <h1>{fulfillmentCenter.name} layout</h1>
            <DeliverySeparator className='delivery-layout-separator' />
            No locations
          </div>
        );
      }

      return (
        <div className='delivery-layout-container'>
          <h1>{fulfillmentCenter.name} layout</h1>
          <DeliverySeparator className='delivery-layout-separator' />
          <DeliveryLayoutRow
            locations={fulfillmentCenterDeliveryLayout.category.children}
            parentNames={[
              ...fulfillmentCenterDeliveryLayout.parents.map((parent) => parent.name),
              fulfillmentCenterDeliveryLayout.category.adminName,
            ]}
            createUrl={this.createUrl}
            fulfillmentCenterName={fulfillmentCenter.name}
            serverStatus={mappedOtherAssignments}
            showHelpText={false}
          />
        </div>
      );
    }
  }

  render() {
    return (
      <Layout>
        <Navigation />
        <Layout.TopBar>
          <Layout.TopBar.Left>
            <Layout.TopBar.Title>Fulfillment Stations</Layout.TopBar.Title>
          </Layout.TopBar.Left>
        </Layout.TopBar>
        <LayoutContent error={this.props.error}>
          <div>{this.renderContent()}</div>
        </LayoutContent>
      </Layout>
    );
  }
}

const query = gql`
  query FulfillmentCenterDeliveryLayoutQuery($venueId: ID!, $fulfillmentCenterId: ID!, $parentLocationId: ID) {
    fulfillmentCenter(venueId: $venueId, fulfillmentCenterId: $fulfillmentCenterId) {
      id
      name
    }
    fulfillmentCenterDeliveryLayout(
      venueId: $venueId
      fulfillmentCenterId: $fulfillmentCenterId
      parentLocationId: $parentLocationId
    ) {
      category {
        ...DeliveryCategoryFields
      }
      parents {
        ...DeliveryLocationFields
      }
    }
    fulfillmentCenterAssignments(venueId: $venueId, fulfillmentCenterId: $fulfillmentCenterId) {
      id
      location {
        ...DeliveryLocationFields
      }
      server {
        id
        name
      }
    }
  }
  ${deliveryCategoryFragment}
  ${deliveryLayoutFragment}
`;

export const FulfillmentCentersDeliveryLayout = (props: RouterProps) => {
  const { venueId, fulfillmentCenterId, parentLocationId } = props.match.params;

  return (
    <Query<FulfillmentCenterDeliveryLayoutQuery, FulfillmentCenterDeliveryLayoutQueryVariables>
      variables={{ venueId, fulfillmentCenterId, parentLocationId }}
      query={query}
    >
      {({ loading, error, data }) => {
        return (
          <FulfillmentCentersDeliveryLayoutUnwrapped
            {...props}
            loading={loading}
            error={error}
            data={data}
            venueId={venueId}
            fulfillmentCenterId={fulfillmentCenterId}
          />
        );
      }}
    </Query>
  );
};
